"use client"

import React from "react"
import ActionItemListCenter from "../ActionItemListCenter"
import InfoFormsList from "../InfoFormsList"
import { FormsAndActionsWrapper } from "./styles"

interface FormsAndActionsItemsListProps {
  itemsList: any[]
  titles: {
    actionsTitle?: string // Title for actions section
    formsTitle?: string // Title for forms section
  }
  links: {
    actionsLink?: any // Link for actions section
    formsLink?: any // Link for forms section
  }
}

const FormsAndActionsItemsList: React.FC<
  React.PropsWithChildren<FormsAndActionsItemsListProps>
> = ({ itemsList, titles, links }) => {
  if (!itemsList) return null

  const actionItems = itemsList.filter((item: any) => item.type === "actions")
  const formsItems = itemsList.filter((item: any) => item.type === "forms")

  return (
    <>
      <FormsAndActionsWrapper>
        {actionItems && actionItems.length > 0 && (
          <ActionItemListCenter
            title={titles.actionsTitle}
            data={actionItems.slice(0, 4)} // Pass the filtered action items
            link={links.actionsLink}
          />
        )}
        {formsItems && formsItems.length > 0 && (
          <InfoFormsList
            title={titles.formsTitle}
            itemsList={formsItems.slice(0, 4)} // Pass the filtered form items
            link={links.formsLink}
          />
        )}
      </FormsAndActionsWrapper>
    </>
  )
}

export default FormsAndActionsItemsList
